import React from 'react';
import { makeStyles } from '@material-ui/core';
import classnames from 'classnames';
import InfoIcon from '@material-ui/icons/Info';
import SuccessIcon from '@material-ui/icons/CheckCircleOutline';
import ErrorIcon from '@material-ui/icons/ErrorOutline';
import WarnIcon from '@material-ui/icons/ReportProblem';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';

const useStyles = makeStyles({
  container: {
    width: '100%',
    backgroundColor: '#EEEEEE',
    borderRadius: '25px'
  },
  singleBox: {
    display: 'flex',
    alignItems: 'center',
    padding: '0 1rem'
  },
  success: {
    backgroundColor: '#4EA037'
  },
  warn: {
    backgroundColor: '#F3B600'
  },
  error: {
    backgroundColor: '#D95045'
  },
  info: {
    backgroundColor: '#F7F7F7',
    color: 'black',
    marginTop: '0.5rem'
  },
  text: {
    paddingLeft: '1rem'
  },
  infoType: {
    backgroundColor: '#2580bd'
  }
});

interface NotificationType {
  type: 'success' | 'warn' | 'error' | 'info';
  msg: string;
  info?: string;
}

const Notification = ({ type, msg, info }: NotificationType) => {
  const classes = useStyles();
  const success = type === 'success';
  const error = type === 'error';
  const warn = type === 'warn';
  const infoType = type === 'info';

  return (
    <div className={classes.container}>
      <div
        className={classnames(
          classes.singleBox,
          success && classes.success,
          warn && classes.warn,
          error && classes.error,
          infoType && classes.infoType
        )}
      >
        {success && <SuccessIcon fill="#fff" />}
        {warn && <WarnIcon fill="#fff" />}
        {error && <ErrorIcon fill="#fff" />}
        {infoType && <InfoOutlinedIcon fill="#fff" />}
        <p className={classes.text}>{msg}</p>
      </div>
      {info && (
        <div className={classnames(classes.info, classes.singleBox)}>
          <InfoIcon fill="black" />
          <p className={classes.text}>{info}</p>
        </div>
      )}
    </div>
  );
};

export default Notification;
